import { styled } from "@mui/material/styles";
import { Box, Paper } from "@mui/material";

/* retro redesign accent — not part of the MUI palette */
export const mustard = '#f2c94c';

/* large header at the top of each page */
export const PageHeader = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  textAlign: "left",
  width: "fit-content",
  margin: "30px 0 0 30px",
  padding: "30px 30px",
}))

export const ContainerDiv = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  position: "relative",
  width: "100%",
  marginTop: "100px",
}))

export const CustomImage = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  marginTop: "100px",
}))

/* headers */
export const CustomPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  position: "absolute",
  bottom: "-40px",
  left: "50%",
  transform: "translateX(-50%)",
  width: "fit-content",
  padding: "10px",
}))

/* the green line in the footer */
export const FooterDivider = styled(Box)(({ theme })=> ({
  backgroundColor: theme.palette.primary.main,
  marginTop: "20px",
  marginBottom: "10px",
  height: 5,
  marginLeft: "100px",
  marginRight: "100px",
  width: "full",
}));

/* used for paper headers */
export const BackgroundPaper = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
  }));